var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftClouds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 380.37,
    height: 115.434,
    viewBox: "0 0 380.37 115.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.748,15.712C38.71,15.712,9.164,45.482,0,86.153H147.5C138.331,45.482,108.785,15.7,73.748,15.7",
    transform: "translate(0 2.84)",
    fill: "#bfe3e8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M270.948,25.56c-35.037,0-64.584,29.782-73.748,70.453H344.7c-9.164-40.67-38.71-70.453-73.748-70.453",
    transform: "translate(35.675 4.624)",
    fill: "#bfe3e8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M194.619,0C144.572,0,102.366,42.536,89.27,100.625H299.955C286.871,42.536,244.665,0,194.619,0",
    transform: "translate(16.149)",
    fill: "#bfe3e8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.374,66.41c-18.41,0-33.927,15.647-38.734,37.01h77.467C109.3,82.057,93.772,66.41,75.374,66.41",
    transform: "translate(6.628 12.014)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.864,66.41c-18.41,0-33.927,15.647-38.734,37.01H203.6c-4.806-21.363-20.335-37.01-38.734-37.01",
    transform: "translate(22.818 12.014)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.767,52.98c-26.287,0-48.453,22.343-55.337,52.857H180.093c-6.873-30.515-29.05-52.857-55.337-52.857",
    transform: "translate(12.56 9.584)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftClouds);
export default __webpack_public_path__ + "static/media/left-clouds.6d70192ee113ffab48152dcc6fe400e1.svg";
export { ForwardRef as ReactComponent };